import { Typography } from "@/components/atoms";

/**
 * Slim persistent banner over the assistant-scoped booking surfaces (DEV-1296), naming the managed
 * client the draft belongs to so the EA always knows whose booking it is. Mirrors the operator's
 * OperatorBookingBanner styling, but takes the name directly — the access link already carries it,
 * so no extra profile fetch is needed.
 */
export const AssistantBookingBanner = ({ name }: { name: string }) => (
  <div className="shrink-0 bg-vivid-purple-dark px-3 py-2.5 lg:px-5">
    <Typography variant="action" className="text-white">
      Booking for {name || "your client"}
    </Typography>
  </div>
);
